export default "__VITE_ASSET__f66aa0d2__"